module.exports = __webpack_public_path__ + "img/115.90887668.png";